import { render, staticRenderFns } from "./GameEmbedVideo.vue?vue&type=template&id=8b838f62"
import script from "./GameEmbedVideo.vue?vue&type=script&lang=js"
export * from "./GameEmbedVideo.vue?vue&type=script&lang=js"
import style0 from "./GameEmbedVideo.vue?vue&type=style&index=0&id=8b838f62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports